@if (service.showBanner()) {
  <div class="purchase-profile-banner">
    <div class="banner-icon-wrapper">
      <i class="fa-solid fa-bullseye" aria-hidden="true"></i>
    </div>

    <div class="banner-text">
      <strong class="banner-title">Descubra o perfil de compra da sua loja</strong>
      <span class="banner-desc">
        5 perguntas rápidas para mostrarmos primeiro os veículos com a margem que você busca.
      </span>
    </div>

    <button type="button" class="btn btn-primary banner-action-btn" (click)="openWizard()">
      Descobrir meu perfil
    </button>
  </div>
}
